import type { VertexesJson } from 'contracts/PMIJson';
import type {
  // BufferGeometry,
  // MeshBasicMaterial,
  Color,
} from 'three';
import { Mesh, Group } from 'three';

//eslint-disable-next-line no-restricted-imports
import { getFrontSideMaterial } from '../../materials';
import { VERTEX_GEOMETRY_SPHERE } from '../step/StepVertexBody';

//eslint-disable-next-line no-restricted-imports
// import { mergeGeometries } from '../../utils/BufferGeometryUtils';

//WIP attempted optimization that doesn't work
// export const parseVertexes = (
//   pointsJson: VertexesJson['vertexes'],
//   color: Color | null,
// ): Mesh<BufferGeometry, MeshBasicMaterial> => {
//   //collect spheres for each vertices, and merge geometry for performance
//   const unmergedVertexes = pointsJson.map((pointJson) => {
//     return VERTEX_GEOMETRY_SPHERE.clone().translate(...pointJson)
//   });
//   const vertexes = mergeGeometries(unmergedVertexes);
//   // unmergedVertexes.forEach((vertex) => { vertex.dispose()});
//   return new Mesh(vertexes, getFrontSideMaterial(color));
// };

export const parseVertexes = (
  pointsJson: VertexesJson['vertexes'],
  color: Color | null,
): Group => {
  const material = getFrontSideMaterial(color);
  return new Group().add(
    ...pointsJson.map((pointJson) => {
      const vertex = new Mesh(VERTEX_GEOMETRY_SPHERE, material);
      vertex.position.set(...pointJson);
      return vertex;
    }),
  );
};
